import { Reveal, Tag, ClipReveal, ArrowLink } from "../components/Shared";
import { STORIES } from "../data/content";

export default function JournalPage() {
  return (
    <div className="bg-ink px-5 pb-32 pt-32 sm:px-10 md:pt-40" data-testid="journal-page">
      <div className="mx-auto max-w-[1600px]">
        <Reveal><Tag>The Journal</Tag></Reveal>
        <h1 className="mt-6 font-serif text-6xl font-light tracking-tight sm:text-7xl lg:text-8xl">
          BEYOND THE <span className="text-fog">COLLECTION</span>
        </h1>
        <Reveal delay={0.15}>
          <p className="mt-5 max-w-lg text-lg font-light text-fog">
            Notes on silhouette, craft and culture — from the house's sketchbook.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-x-8 gap-y-20 md:grid-cols-2">
          {STORIES.map((s, i) => (
            <article key={s.id} className={`group ${i % 2 ? "md:mt-24" : ""}`} data-testid={`journal-story-${s.id}`}>
              <ClipReveal src={s.image} alt={s.title} className="aspect-[4/3]" imgClassName="transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
              <Reveal delay={0.15}>
                <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.35em] text-flame">Story {String(i + 1).padStart(2, "0")}</p>
                <h2 className="mt-3 font-serif text-4xl font-light transition-colors duration-300 group-hover:text-flame">{s.title}</h2>
                <p className="mt-3 text-base font-light italic text-fog">{s.caption}</p>
                <p className="mt-4 max-w-md text-sm font-light leading-relaxed text-fog">
                  The full essay arrives with the journal launch — a look inside the references, fittings and fabric
                  journeys behind each collection.
                </p>
                <div className="mt-6"><ArrowLink to="/collections" testId={`journal-explore-${s.id}`}>Explore the Collections</ArrowLink></div>
              </Reveal>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
